package com.jingfangpai.common.orm.mapping.enums

import org.jooq.ICatalog
import org.jooq.ISchema
import org.jooq.IEnumType
import kotlinx.serialization.Serializable

@Serializable
enum class SignSymptomApplicable(private val literal: String) : IEnumType {
	男性("男性"),
	女性("女性"),
	孕妇("孕妇"),
	产妇("产妇"),
	非孕产妇("非孕产妇");
	override fun getCatalog(): ICatalog? {return null}
	override fun getSchema() :ISchema? {return null}
	override fun getName(): String? {return "sign_symptom_applicable"}
	override fun getLiteral(): String {return literal}
}
